import clsx from "clsx";
import React, { Dispatch, SetStateAction } from "react";

interface TabNavItemProps {
	id: string;
	title: string;
	activeTab: string;
	setActiveTab: Dispatch<SetStateAction<string>>;
}

export function TabNavItem({
	id,
	title,
	activeTab,
	setActiveTab,
}: TabNavItemProps) {
	const isActive = activeTab === id;

	return (
		<li className={clsx("tab-item", { "is-active": isActive })}>
			<button
				role="tab"
				id={`tab-${id}`}
				aria-selected={isActive}
				aria-controls={`pane-${id}`}
				tabIndex={isActive ? 0 : -1}
				className="btn tab-button"
				onClick={() => setActiveTab(id)}
			>
				<span>{title}</span>
			</button>
		</li>
	);
}
